import { render } from "./ConversationSidebarComponent.vue?vue&type=template&id=13019de2&scoped=true"
import script from "./ConversationSidebarComponent.vue?vue&type=script&lang=js"
export * from "./ConversationSidebarComponent.vue?vue&type=script&lang=js"

import "./ConversationSidebarComponent.vue?vue&type=style&index=0&id=13019de2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13019de2"]])

export default __exports__